export default __webpack_public_path__ + "static/badge_most_review-072d90a529c832889d76afe928c0971e.gif";